import {
  SdpExpiredFilter,
  SdpOtherFilter,
  SdpOwnerFilter,
  SdpResponse,
  SdpWaitingFilter,
} from '../models/SdpResponse';
import { atom, selector } from 'recoil';

import { EanURL } from '../common/eanUtils';
import { SDPStatusEnum } from '../enum/SDPStatusEnum';

export interface SDPStateProps {
  items?: SdpResponse[];
}
export const sdpState = atom<SDPStateProps>({
  key: 'sdpState',
  default: { items: [] },
});

const groupSdpsBy = (key: string, sdps?: SdpResponse[]) => {
  let result = sdps?.reduce(
    (result: any, currentValue: any) => {
      (result[currentValue[key]] = result[currentValue[key] || SDPStatusEnum.WAITING] || []).push(
        currentValue
      );
      return result;
    },
    {} as { [key: string]: SdpResponse[] }
  );
  return result ?? {};
};

const sortItem = (a: SdpResponse, b: SdpResponse) => {
  const aValue = (a.userHasAccessNickname ?? a.headpoint.ean).toLowerCase();
  const bValue = (b.userHasAccessNickname ?? b.headpoint.ean).toLowerCase();

  return aValue.toLowerCase().localeCompare(bValue);
};

export const sdpStateGroupedSdps = selector<{
  sdps: SdpResponse[];
  otherSdps: SdpResponse[];
  waitingSdps: SdpResponse[];
  ownSdps: SdpResponse[];
  expiredSdps: SdpResponse[];
}>({
  key: 'sdpStateGroupedSdps',
  get: ({ get }) => {
    const groupedSdps = groupSdpsBy('userHasAccessStatus', get(sdpState).items) as {
      [key: string]: SdpResponse[];
    };
    if (Object.keys(groupedSdps).length) {
      groupedSdps[SDPStatusEnum.ACTIVE]?.sort(sortItem);
      groupedSdps[SDPStatusEnum.INACTIVE]?.sort(sortItem);
      groupedSdps[SDPStatusEnum.WAITING]?.sort(sortItem);
      groupedSdps[SDPStatusEnum.EXPIRED]?.sort(sortItem);
    }
    const sdps = Object.keys(groupedSdps).length
      ? [
          ...(groupedSdps[SDPStatusEnum.ACTIVE] ?? []),
          ...(groupedSdps[SDPStatusEnum.INACTIVE] ?? []),
          ...(groupedSdps[SDPStatusEnum.WAITING] ?? []),
          ...(groupedSdps[SDPStatusEnum.EXPIRED] ?? []),
        ]
      : [];

    const sdpsWithHashId = sdps.map((sdp) => ({
      ...sdp,
      hashId: EanURL.encrypt(sdp.id) as string,
    }));
    const otherSdps = sdpsWithHashId?.filter((sdp) => SdpOtherFilter(sdp));

    const waitingSdps = sdpsWithHashId?.filter((sdp) => SdpWaitingFilter(sdp));

    const ownSdps = sdpsWithHashId.filter((sdp) => SdpOwnerFilter(sdp));

    const expiredSdps = sdpsWithHashId.filter((sdp) => SdpExpiredFilter(sdp));

    return {
      sdps: sdpsWithHashId,
      otherSdps,
      waitingSdps,
      ownSdps,
      expiredSdps,
    };
  },
});
